import React from 'react';
import { RCGrid } from '@reverbdotcom/cadence/components';

interface ExternalProps {
  title: JSX.Element | string;
  subtitle?: JSX.Element | string;
  collection: JSX.Element;
  callToAction?: JSX.Element;
  id?: string;
}

export default function IndentedRow(props: ExternalProps) {
  const titleId = props.id && `overflowing-row_heading-${props.id}`; // acts as overflowing row header while visible

  function indentedTitle() {
    return (
      <div className="indented-row-titles">
        <h2 className="indented-row__title" id={titleId}>
          {props.title}
        </h2>
        {!!props.subtitle &&
          <small className="d-block">
            {props.subtitle}
          </small>
        }
        {
          props.callToAction &&
          <div className="indented-row__action" aria-describedby={titleId}>
            {props.callToAction}
          </div>
        }
      </div>
    );
  }

  return (
    <div className="indented-row-content">
      <RCGrid singleRowOn="all">
        <RCGrid.Item
          key={0}
          colSpan={{
            desktop: 4,
          }}
          hideOn="tabletAndMobile"
        >
          {indentedTitle()}
        </RCGrid.Item>
        <RCGrid.Item
          key={1}
          colSpan={{
            desktop: 8,
            tablet: 12,
            mobile: 12,
          }}
        >
          <div className="indented-row-collection">
            {props.collection}
          </div>
        </RCGrid.Item>
      </RCGrid>
    </div>
  );
}
